// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import FindUsSection from "./components/FindUsSection";
import About from "./components/About";
import NewsletterSection from "./components/NewsletterSection";
import Footer from "./components/Footer";
import MenuSection from "./components/MenuSection";
import UpcomingEventsSection from "./components/UpcomingEventsSection";
import VideoCarousel from "./components/VideoCarousel";
import ReservationForm from "./components/ReservationForm";
import SuccessPage from "./components/SuccessPage";    // For paid reservations
import UnpaidSuccessPage from "./components/UnpaidSuccessPage";  // For unpaid reservations
import CancelPage from "./components/CancelPage";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import ScrollToTop from "./components/ScrollToTop";
import BottleService from "./components/BottleService";
import Event from "./components/Event";
import AOS from "aos";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PopularDishesSection from "./components/PopularDishesSection";
import SpecialReservationSection from "./components/SpecialReservationSection";
import AbouUs from "./components/AbouUs"; // Typo kept
import SignIn from "./managerPortal/pages/SignIn";
import ManagerDashboard from "./managerPortal/pages/ManagerDashboard";
import EventManagement from "./managerPortal/pages/EventsPage";
import MenuManagement from "./managerPortal/pages/MenuManagementPage";
import ReservationManagement from "./managerPortal/pages/ReservationsPage";
import "../src/icons/fontawesome";
import NoAccess from "./managerPortal/pages/NoAccess";


// Layouts
const NoNavbarLayout = () => <Outlet />;
const DefaultLayout = () => (
    <>
        <Navbar />
        <Outlet />
    </>
);

// Stripe
const stripePromise = loadStripe("pk_test_51Qi4ecG8aXZO2i1pej3LJXlV6b1l8dDpkYrsxuhtyo0jxXpSCXz201h4OB8Njk2eWaP53iT70u4w7Rhh5260ylB100x7iySqrZ");

function App() {
    useEffect(() => {
        AOS.init();
    }, []);

    return (
        <Router>
            <ScrollToTop />
            <Routes>
                {/* 1) No Navbar Layout for Manager Portal */}
                <Route element={<NoNavbarLayout />}>
                    <Route path="manager/signin" element={<SignIn />} />
                    <Route path="manager/dashboard" element={<ManagerDashboard />} />
                    <Route path="manager/event" element={<EventManagement />} />
                    <Route path="manager/menu" element={<MenuManagement />} />
                    <Route path="manager/reservations" element={<ReservationManagement />} />
                    <Route path="manager/no-access" element={<NoAccess />} />
                </Route>

                {/* 2) Default Layout for Customer-Facing Pages */}
                <Route element={<DefaultLayout />}>
                    {/* Landing Page */}
                    <Route
                        path="/"
                        element={
                            <>
                                <HeroSection />
                                <About />
                                <PopularDishesSection />
                                <VideoCarousel />
                                <UpcomingEventsSection />
                                <SpecialReservationSection />
                                <FindUsSection />
                                <Footer />
                            </>
                        }
                    />
                    {/* Menu Page */}
                    <Route
                        path="/menu"
                        element={
                            <>
                                <MenuSection />
                                <Footer />
                            </>
                        }
                    />
                    {/* About Page */}
                    <Route
                        path="/about"
                        element={
                            <>
                                <AbouUs />
                                <Footer />
                            </>
                        }
                    />
                    {/* Bottle Page */}
                    <Route
                        path="/bottleservice"
                        element={
                            <>
                                <BottleService />
                                <Footer />
                            </>
                        }
                    />
                    {/* Events Page */}
                    <Route
                        path="/events"
                        element={
                            <>
                                <Event />
                                <Footer />
                            </>
                        }
                    />
                    {/* Reservation Page */}
                    <Route
                        path="/reserve"
                        element={
                            <Elements stripe={stripePromise}>
                                <ReservationForm />
                            </Elements>
                        }
                    />
                    {/* Success & Cancel Pages */}
                    <Route path="/success" element={<SuccessPage />} />
                    <Route path="/reservation-success-unpaid" element={<UnpaidSuccessPage />} />
                    <Route path="/cancel" element={<CancelPage />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;
